export default __webpack_public_path__ + "static/media/codesandbox.80cdb264.svg";